
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bags",
      function () {
        return require("private-next-pages/bags/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bags"])
      });
    }
  